export default __webpack_public_path__ + "static/media/notify-check-tick.dd4865ea.svg";